module.exports = __webpack_public_path__ + "img/最美证件照216.db7bcab6.png";